import { Service, signal } from '@angular/core';

import { UserCultureEnum } from '../enums/user-culture.enum.model';
import { UserInfo } from '../models/user-info.model';

/**
 * Store di dominio per la sessione utente (ADR 002).
 * Fonte di verità: i signal. Invariante: ogni scrittura passa dai setter.
 */
@Service()
export class SessionStore {
  private readonly _userInfo = signal<UserInfo | null>(null);
  readonly userInfo = this._userInfo.asReadonly();

  private readonly _isUserGuest = signal<boolean>(false);
  readonly isUserGuest = this._isUserGuest.asReadonly();

  setUserInfo(userInfo: UserInfo | null): void {
    this._userInfo.set(userInfo);
  }

  /** COPIA immutabile: la vecchia mutazione per riferimento cambiava il valore senza emissione. */
  setCulture(culture: UserCultureEnum): void {
    const current = this._userInfo();
    if (!current) return;
    this.setUserInfo(new UserInfo({ ...current, culture }));
  }

  setIsUserGuest(isGuest: boolean): void {
    this._isUserGuest.set(isGuest);
  }
}
